import * as utils from '../utils/request';
import { firebaseAuth } from '../plugins/firebase';
import store from './store';
import _ from 'lodash';

/**
 * @typedef {Object} UserCredentials
 * @property {string} email
 * @property {string} password
 */

/**
 * @typedef {Object} Account
 */

/**
 * @typedef {Object} Organization
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {string} picURL
 * @property {Admin[]} admins
 */

store.registerModule('auth', {
  namespaced: true,
  state: {
    account: {}
  },
  actions: {
    /**
     * @param ctx
     * @param {UserCredentials} opts
     * @param {string} opts.email
     * @param {string} opts.password
     * @returns {Organization}
     */
    async adminSignIn (ctx, opts) {
      const { user } = await ctx.dispatch('signIn', opts);
      const account = await ctx.dispatch('getAccount', user.uid);
      if (!account) throw new Error('no-account');
      if (account && !account.isAdmin) throw new Error('not-admin');
      if (account && !account.isAdminOf) throw new Error('not-admin-of-any-org');
      const org = await ctx.dispatch('organization/getOrganization', {
        id: account.isAdminOf
      }, { root: true });
      ctx.commit('setAccount', account);
      return org;
    },
    /**
     * @param ctx
     * @param {UserCredentials} opts
     * @param {string} opts.email
     * @param {string} opts.password
     */
    async signIn (ctx, opts) {
      return firebaseAuth.signInWithEmailAndPassword(opts.email, opts.password);
    },
    async signout (ctx) {
      await firebaseAuth.signOut();
      ctx.commit('setAccount');
    },
    /**
     * @param ctx
     * @param {string} uid
     */
    async getAccount (ctx, uid) {
      if (!_.isEmpty(ctx.state.account)) return ctx.state.account;
      const account = await utils.request(`accounts/${uid}`, {
        method: 'get'
      });
      ctx.commit('setAccount', account);
      return account;
    }
  },
  mutations: {
    setAccount: (s, val) => {
      s.account = val;
    }
  }
});
